import { Alert, Box, Button, Snackbar, TextField, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import CodeInputPopup from "./CodeInputPopup";
import { QrScanner } from 'react-qrcode-scanner';
import { API_URL } from "../ApiConfig";
import BottomSheetPopup from "./BottomSheetPopup";

function EventValidationScreen() {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [enteredCode, setEnteredCode] = useState(null);
    const [verified, setVerified] = useState(false)
    const [eventDetails, setEventDetails] = useState({})
    const [currentTicket, setCurrentTicket] = useState({})
    const [totalRegistered, setTotalRegistered] = useState(0)
    const [totalRedeemed, setTotalRedeemed] = useState(0)
    const [notRedeemed, setNotRedeemed] = useState(0)
    const [scanning, setScanning] = useState(false)
    const [verifiedCode, setVerifiedCode] = useState("")
    const [loading, setLoading] = useState(false)
    const [snackbarText, setSnackbarText] = useState("")
    const [snackbarType, setSnackBarType] = useState(0)
    const [ticketNumber, setTicketNumber] = useState("")

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleSubmit = (code) => {
        verifyCode(code)
    };


    const isMobileScreen = useMediaQuery('(max-width:900px)');

    // Parse query parameters
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        handleOpen()
    }, [])


    const handleScan = (value) => {
        console.log({ value });
        setScanning(true)
        if (!loading) {
            getTicketDetails(value)
        }
    };

    const handleError = (error) => {
        console.log({ error });
    };


    const verifyCode = async (code) => {
        const response = await fetch(`${API_URL}/community/check-evt-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: code, eventId: id })
        });
        const json = await response.json();
        if (json.success) {
            setOpen(false)
            setVerifiedCode(json.code)
            setSnackBarType(0)
            setSnackbarText("Code has been verified")
            getEventDetails(json.code)
            setVerified(true)
        } else {
            setSnackBarType(1)
            setSnackbarText(json.response ? json.response : "Error processing your request.")
        }
    }


    const getEventDetails = async (code) => {
        const response = await fetch(`${API_URL}/community/get-evt-by-id/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-code': code
            },
        });
        const json = await response.json();
        if (json.success) {
            setEventDetails(json.event)
            setTotalRedeemed(json.metrics.totalRedeemed)
            setNotRedeemed(json.metrics.notRedeemed)
            setTotalRegistered(json.metrics.totalRegistered)
        } else {
            setSnackBarType(1)
            setSnackbarText(json.response)
        }
    }


    const getTicketDetails = async (ticketNumber) => {
        setLoading(true)
        const response = await fetch(`${API_URL}/community/get-evt-tkt/${id}?tin=${ticketNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-code': verifiedCode
            },
        });
        const json = await response.json();
        if (json.success) {
            setTicketNumber("")
            setCurrentTicket(json.response)
            setLoading(false)
        } else {
            setSnackBarType(1)
            setSnackbarText(json.response)
            setLoading(false)
        }
    }


    const approveTicket = async (ticketNumber) => {
        const response = await fetch(`${API_URL}/community/approve-tkt/${id}/${ticketNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-code': verifiedCode.toString()
            },
        });
        const json = await response.json();
        if (json.success) {
            setCurrentTicket({})
            setSnackBarType(0)
            setSnackbarText(json.response)
            getEventDetails(verifiedCode)
        } else {
            setSnackBarType(1)
            setSnackbarText(json.response)
        }
    }



    function formatDate(dateString) {
        if (!dateString) return "—";

        const date = new Date(dateString);

        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }

    return (
        <Box display={'flex'} flex={1} sx={{ width: "100vw", height: "100vh", flexDirection: 'column' }}>
            {
                isMobileScreen && (
                    <Box flexDirection={"column"} sx={{ width: "100vw", height: "100vh", padding: "20px", overflow: 'scroll' }}>

                        {
                            verified && (
                                <Box sx={{ flexDirection: 'column', alignSelf: 'stretch' }}>
                                    <Typography style={{ fontFamily: "poppins", fontWeight: 700, fontSize: "22px" }} >{eventDetails.title || "Untitled Event"}</Typography>
                                    <Typography style={{ fontFamily: "poppins", fontWeight: 400, fontSize: "13px" }} >{eventDetails.startDate ? formatDate(eventDetails.startDate) : "21 Aug 2025, 07:00PM"}</Typography>
                                    <Box sx={{
                                        flexDirection: "column", alignItems: 'center', justifyContent: 'center',
                                        borderRadius: "100px", border: "1.5px solid #aaaaaa20", display: 'flex',
                                        paddingBlock: "8px", paddingInline: "10px", alignSelf: 'flex-start', marginTop: "20px"
                                    }}>

                                        <Typography style={{
                                            fontFamily: "poppins",
                                            fontWeight: 500,
                                            color: "#000000",
                                            fontSize: "13px", alignSelf: 'center', textAlign: 'center'
                                        }} >Total Registered: {totalRegistered}</Typography>


                                    </Box>
                                    <Box sx={{
                                        overflow: 'hidden', alignSelf: "stretch", aspectRatio: 1 / 1, borderRadius: "10px", border: "4px solid #aaaaaa20",
                                        background: "#000000", marginTop: "20px"
                                    }}>

                                        {
                                            !scanning && !loading ? (
                                                <QrScanner
                                                    facingMode={'environment'}
                                                    delay={400}
                                                    aspectRatio="1:1"
                                                    showViewFinder={false}
                                                    style={{ alignSelf: 'stretch', aspectRatio: 1 / 1, background: "#000000", transform: "scaleX(-1)" }}
                                                    onScan={handleScan} onError={handleError} />
                                            ) : <Box />
                                        }

                                    </Box>


                                    <Typography style={{
                                        fontFamily: "poppins",
                                        fontWeight: 400,
                                        color: "#404040",
                                        marginTop: "20px",
                                        fontSize: "16px", alignSelf: 'center', textAlign: 'center'
                                    }} >Place the qr inside the block to scan.</Typography>


                                     <Typography style={{
                                        fontFamily: "poppins",
                                        fontWeight: 400,
                                        color: "#aaaaaa",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        fontSize: "16px", alignSelf: 'center', textAlign: 'center'
                                    }} >- or -</Typography>




                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Ticket Number"
                                        type={'text'}
                                        fullWidth
                                        variant={'filled'}
                                        value={ticketNumber}
                                        sx={{
                                            input: { color: "#6d5b5bff", fontFamily: "poppins", fontWeight: 400, },

                                            // label color
                                            "& .MuiInputLabel-root": { color: "#aaaaaa" },
                                            "& .MuiInputLabel-root.Mui-focused": { color: "#303030", fontFamily: "poppins" },

                                            // stroke (border) color
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": { borderColor: "#aaaaaa30", borderWidth: "2px" },          // default
                                                "&:hover fieldset": { borderColor: "#706dea" },   // on hover
                                                "&.Mui-focused fieldset": { borderColor: "#706dea" }, // on focus
                                            },
                                        }}
                                        onChange={(e) => setTicketNumber(e.target.value)}
                                    />

                                    {
                                        ticketNumber.length > 4 && (
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                sx={{
                                                    mt: "15px", borderRadius: 100, paddingBlock: "15px", fontFamily: "poppins", fontSize: "14px", textTransform: 'none',
                                                    background: "#000000", color: "#ffffff",
                                                    boxShadow: 'none'
                                                }}
                                                onClick={() => {
                                                    getTicketDetails(ticketNumber)
                                                }}>Check Ticket</Button>
                                        )
                                    }




                                    <Box sx={{ height: "1px", background: "#aaaaaa20", marginTop: "30px", alignSelf: 'stretch' }} />



                                    <Box sx={{
                                        flexDirection: 'row', alignItems: 'center', gap: "15px", display: 'flex',
                                        marginTop: "20px", marginInline: "10px", marginBottom: "50px"
                                    }}>

                                        <Box sx={{
                                            flexDirection: "column", alignItems: 'center', justifyContent: 'center',
                                            borderRadius: "10px", border: "1.5px solid #aaaaaa20",
                                            paddingBlock: "15px", display: 'flex', flex: 1
                                        }}>
                                            <Typography style={{
                                                fontFamily: "poppins",
                                                fontWeight: 600,
                                                fontSize: "20px", alignSelf: 'center', textAlign: 'center'
                                            }} >{totalRedeemed}</Typography>

                                            <Typography style={{
                                                fontFamily: "poppins",
                                                fontWeight: 400,
                                                color: "#303030",
                                                fontSize: "13px", alignSelf: 'center', textAlign: 'center'
                                            }} >Approved</Typography>


                                        </Box>

                                        <Box sx={{
                                            flexDirection: "column", alignItems: 'center', justifyContent: 'center',
                                            borderRadius: "10px", border: "1.5px solid #aaaaaa20",
                                            paddingBlock: "15px", display: 'flex', flex: 1
                                        }}>
                                            <Typography style={{
                                                fontFamily: "poppins",
                                                fontWeight: 600,
                                                fontSize: "20px", alignSelf: 'center', textAlign: 'center'
                                            }} >{notRedeemed}</Typography>

                                            <Typography style={{
                                                fontFamily: "poppins",
                                                fontWeight: 400,
                                                color: "#303030",
                                                fontSize: "13px", alignSelf: 'center', textAlign: 'center'
                                            }} >Waiting</Typography>


                                        </Box>
                                    </Box>




                                </Box>
                            )
                        }

                        <Snackbar
                            open={snackbarText.length > 0}
                            autoHideDuration={2000}
                            onClose={() => {
                                setSnackbarText("")
                                setScanning(false)
                            }}
                            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        >
                            <Alert severity={snackbarType == 0 ? 'success' : 'error'} onClose={() => {
                                setSnackbarText("")
                                setScanning(false)
                            }}>
                                {snackbarText}
                            </Alert>
                        </Snackbar>

                        <BottomSheetPopup onApprove={() => {
                            approveTicket(currentTicket.ticketNumber)
                        }} data={currentTicket} open={currentTicket._id ? true : false} close={() => {
                            setCurrentTicket({})
                            setSnackBarType(0)
                            setSnackbarText("Ticket already verified")
                            getEventDetails(verifiedCode)
                        }} />

                        <CodeInputPopup
                            open={open}
                            onClose={handleClose}
                            onSubmit={handleSubmit}
                        />

                    </Box>
                )
            }



        </Box>
    );
}

export default EventValidationScreen;
